// extracted by mini-css-extract-plugin
module.exports = {"tag":"wzRKAZ","small":"KkqSwz","regular":"_6b_lkt"};